import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Collapse, Alert } from "react-bootstrap";
import CustomButton from "../../../common/CustomButton";
import { AcceptIcon, CloseIcon, CrossIcon, EditIcon } from "../../../../assets/svg/svg-icons";
import { useSelector, useDispatch } from "react-redux";
import { getApi, postBrandStatus, postProductStatus } from "../../../../actions/structure.action";
import isEmpty from "../../../../utils/is-Empty";
import { DummyDataNewOrders, tableStructures } from "../../../../helpers/table-structures";
import Spinner from "../../../common/Spinner";
import ProductCrud from "../../common/ProductCrud";
import BrandCrud from "../../common/BrandCrud";
import StatCard from "../../../common/StatCard";
import CustomTable from "../../common/CustomTable";
import CustomModalWrap from "../../../common/CustomModalWrap";
import DashbordOrder from "../../common/DashbordOrder/indes";
import TotalUsers from "../../../../assets/images/icons/TotalUsers.png";
import TotalBrands from "../../../../assets/images/icons/TotalBrands.png";
import TotalProducts from "../../../../assets/images/icons/TotalProducts.png";
import EnquiryDetails from "../../../Enquiry/EnquiryDetails";
import moment from "moment";
import { Link } from "react-router-dom";
import { stringConstants } from "../../../../helpers";

const Dashbord = ({ scrollRef }) => {
  const dispatch = useDispatch();

  const [filterPendingOrdersArray, setFilterPendingOrdersArray] = useState([]);
  const [filterProductsPendingArray, setFilterProductsPendingArray] = useState([]);
  const [filterBrandPendingArray, setFilterBrandPendingArray] = useState([]);
  const [showProductUpdatedMode, setShowProductUpdatedMode] = useState(false);
  const [showBrandUpdateMode, setShowBrandUpdateMode] = useState(false);
  const [uploadFormObj, setUploadFormObj] = useState({});
  const [selectedFormObj, setSelectedFormObj] = useState({});
  const [showOrderModal, setOrderModal] = useState(false);
  const [currentOrderId, setCurrentOrderId] = useState("");
  const [pendingEnquiries, setPendingEnquiries] = useState([]);
  const [isFirstDay, setIsFirstDay] = useState(false);

  const { brands, products, adminStats, orders, enquiry } = useSelector((state) => {
    return state;
  });

  const orderViewToggle = () => setOrderModal(!showOrderModal);

  useEffect(() => {
    getApi("getBrands", dispatch);
    getApi("getProducts", dispatch);
    getApi("getAdminStats", dispatch);
    getApi("getOrders", dispatch);
    getApi("getEnquiry", dispatch);

    setIsFirstDay(moment().date() === 1);
    getApi("getLastMonthPendingPayouts", dispatch).then((res) => {
      if (!isEmpty(res?.payload?.total_orders) && res?.payload?.total_orders > 0) {
        setIsFirstDay(true);
      } else {
        setIsFirstDay(false);
      }
    });
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(enquiry?.data?.enquiryDetails) && enquiry?.data?.enquiryDetails.length > 0) {
      const tempPendingEnquiries = enquiry?.data?.enquiryDetails.filter(
        (item) => item.enquiry_status === "pending",
      );
      if (tempPendingEnquiries.length > 0) {
        tempPendingEnquiries.sort(
          (a, b) => new Date(b.enquiryCreatedAt) - new Date(a.enquiryCreatedAt),
        );
        setPendingEnquiries(tempPendingEnquiries);
      } else {
        setPendingEnquiries([]);
      }
    }
  }, [enquiry]);

  useEffect(() => {
    if (orders?.data?.length > 0) {
      const filtered = orders?.data.filter(
        (item) => item.status === "inprocess" || item.status === "placed",
      );
      if (filtered.length > 0) {
        filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setFilterPendingOrdersArray(filtered);
      } else {
        setFilterPendingOrdersArray([]);
      }
    }
  }, [orders]);

  useEffect(() => {
    if (products?.data?.length > 0) {
      const filtered = products?.data.filter((item) => item.product_status === "pending"); // Replace with your desired filter condition
      if (filtered.length > 0) {
        setFilterProductsPendingArray(filtered);
      } else {
        setFilterProductsPendingArray([]);
      }
    }
  }, [products]);

  useEffect(() => {
    if (brands?.data?.length > 0) {
      const filtered = brands?.data.filter((item) => item.brand_status === "pending"); // Replace with your desired filter condition
      if (filtered.length > 0) {
        filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setFilterBrandPendingArray(filtered);
      } else {
        setFilterBrandPendingArray([]);
      }
    }
  }, [brands]);

  const pendingEnquiriesComp = () => {
    return pendingEnquiries.length > 0 && !enquiry.loading ? (
      <Row className="section-row m-0 mb-4 no-records px-0 py-1">
        <CustomTable
          enableRowActions
          data={pendingEnquiries}
          enableTopToolbar={true}
          enableBottomToolbar={true}
          enablePagination={true}
          enableFilters={false}
          positionActionsColumn={"last"}
          emptyTableMsg={`No new enquiries available at the moment.`}
          columns={tableStructures.pending_enquiries}
          initialState={{
            columnPinning: {
              right: ["mrt-row-actions"],
            },
          }}
          renderTopToolbarCustomActions={({ table }) => (
            <Row style={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}>
              <h4>{"Pending Enquiries"}</h4>
            </Row>
          )}
          renderRowActions={({ row, table }) => (
            <div className="table-action-box">
              <CustomButton
                buttonClasses="action-button accept"
                id={row.original.id}
                onClick={() => {
                  setCurrentEnquiryPkId(row.original.enquiry_pk_id);
                  enquiryViewToggle();
                }}
              >
                {"View"}
              </CustomButton>
            </div>
          )}
        />
      </Row>
    ) : (
      <Container className="no-records mb-4 pb-4 w-100">
        <h4 className="title">{"Pending Enquiries"}</h4>
        <p>{"No pending enquiries data..."}</p>
      </Container>
    );
  };

  const pendingOrders = () => {
    return filterPendingOrdersArray.length > 0 && !orders.loading ? (
      <Row className="section-row m-0 mb-4 no-records px-0 py-1">
        <CustomTable
          enableRowActions
          data={filterPendingOrdersArray}
          enableTopToolbar={true}
          columns={tableStructures.new_orders}
          enableBottomToolbar={true}
          enablePagination={true}
          enableFilters={false}
          emptyTableMsg={"No data found"}
          positionActionsColumn={"last"}
          initialState={{
            columnPinning: {
              right: ["mrt-row-actions"],
            },
          }}
          renderTopToolbarCustomActions={({ table }) => (
            <Row style={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}>
              <h4>{"Orders Not Accepted"}</h4>
            </Row>
          )}
          renderRowActions={({ row, table }) => (
            <div className="table-action-box">
              {/* {OrderDetailsModal(row.original.id)} */}
              <CustomButton
                buttonClasses="action-button accept"
                onClick={() => {
                  setCurrentOrderId(row.original.id);
                  orderViewToggle();
                }}
              >
                {"View"}
              </CustomButton>
            </div>
          )}
        />
      </Row>
    ) : (
      <Container className="no-records mb-4 pb-4">
        <h4 className="title">{"Orders Not Accepted"}</h4>
        <p>{"No pending orders data..."}</p>
      </Container>
    );
  };

  const pendingProducts = () => {
    if (!showProductUpdatedMode) {
      if (filterProductsPendingArray?.length > 0 && !products.loading) {
        return (
          <Row className="m-0 mb-4 no-records px-0 py-1">
            <CustomTable
              columns={tableStructures.admin_product}
              data={filterProductsPendingArray}
              enableRowActions={true}
              positionActionsColumn={"last"}
              enableTopToolbar={true}
              emptyTableMsg={""}
              enablePagination={true}
              enableBottomToolbar={true}
              enableFilters={true}
              displayColumnDefOptions={{
                "mrt-row-actions": {
                  header: "Edit/Accept/Reject",
                },
              }}
              renderRowActions={({ row, table }) => (
                <div className="table-action-box">
                  {/* {brandModal("icon-action-btn", <EditIcon />, row.original)} */}
                  <CustomButton
                    buttonClasses="icon-action-btn"
                    onClick={() => {
                      setShowProductUpdatedMode(true);
                      setSelectedFormObj(row.original);
                    }}
                  >
                    <EditIcon />
                  </CustomButton>
                  <CustomButton
                    buttonClasses="icon-action-btn"
                    onClick={() => {
                      postProductStatus(
                        {
                          product_id: row.original.id,
                          product_status: "accept",
                        },
                        dispatch,
                      );
                    }}
                  >
                    <AcceptIcon />
                  </CustomButton>
                  <CustomButton
                    buttonClasses="icon-action-btn"
                    onClick={() =>
                      postProductStatus(
                        {
                          product_id: row.original.id,
                          product_status: "reject",
                        },
                        dispatch,
                      )
                    }
                  >
                    <CrossIcon />
                  </CustomButton>
                </div>
              )}
              renderTopToolbarCustomActions={({ table }) => (
                <div className="table-heading-wrap">
                  <h4>{"Products Pending Requests"}</h4>
                </div>
              )}
              initialState={{
                columnPinning: {
                  right: ["mrt-row-actions"],
                },
                sorting: [
                  { id: "createdAt", desc: true }, // default sort by startDate DESC
                ],
              }}
              //   enableColumnOrdering={false} //enable some features
              //   enableRowSelection={false}
              //   enableColumnResizing={false}
              //   onRowSelectionChange={setRowSelection} //hoist internal state to your own state (optional)
              //   state={{ rowSelection }} //manage your own state, pass it back to the table (optional)
              //   tableInstanceRef={tableInstanceRef} //get a reference to the underlying table instance (optional)
            />
          </Row>
        );
      } else if (products.loading) {
        return <Spinner />;
      } else {
        return (
          <Container className="no-records mb-4 pb-4">
            <h4 className="title">{"Products pending requests"}</h4>
            <p>{"No pending products requests data..."}</p>
          </Container>
        );
      }
    } else if (showProductUpdatedMode) {
      return (
        <Container className="seller-product-create-form modal-custom-class">
          <ProductCrud
            product={selectedFormObj}
            setShowProductCreateMode={setShowProductUpdatedMode}
            renderInfo={
              <>
                {" "}
                {!isEmpty(selectedFormObj) && (
                  <Row className="m-0 px-0 mb-4">
                    <Col xs={4} className="px-3">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>{"Seller business name"}</Form.Label>
                        <h6>{selectedFormObj?.seller.business_name}</h6>
                      </Form.Group>
                    </Col>
                    <Col xs={4} className="px-3">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>{"Seller mobile number"}</Form.Label>
                        <h6>{selectedFormObj?.seller.mobile_number}</h6>
                      </Form.Group>
                    </Col>
                    <Col xs={4} className="px-3">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>{"Seller email"}</Form.Label>
                        <h6>{selectedFormObj?.seller.email}</h6>
                      </Form.Group>
                    </Col>
                  </Row>
                )}
              </>
            }
          />
        </Container>
      );
    }
  };

  const pendingBrands = () => {
    if (!showBrandUpdateMode) {
      if (filterBrandPendingArray?.length > 0 && !brands.loading) {
        return (
          <Row className="m-0 mb-4 no-records px-0">
            <CustomTable
              columns={tableStructures.seller_brand}
              data={filterBrandPendingArray}
              enableRowActions={true}
              positionActionsColumn={"last"}
              enableTopToolbar={true}
              emptyTableMsg={""}
              enablePagination={true}
              enableBottomToolbar={true}
              enableFilters={true}
              displayColumnDefOptions={{
                "mrt-row-actions": {
                  header: "Edit/Accept/Reject",
                },
              }}
              renderRowActions={({ row }) => (
                <div className="table-action-box">
                  {/* {brandModal("icon-action-btn", <EditIcon />, row.original)} */}
                  <CustomButton
                    buttonClasses="icon-action-btn"
                    onClick={() => {
                      setShowBrandUpdateMode(true);
                      setUploadFormObj(row.original);
                    }}
                  >
                    <EditIcon />
                  </CustomButton>
                  <CustomButton
                    buttonClasses="icon-action-btn"
                    onClick={() => {
                      postBrandStatus(
                        {
                          brand_id: row.original.id,
                          brand_status: "accept",
                        },
                        dispatch,
                      );
                    }}
                  >
                    <AcceptIcon />
                  </CustomButton>
                  <CustomButton
                    buttonClasses="icon-action-btn"
                    onClick={() =>
                      postBrandStatus(
                        {
                          brand_id: row.original.id,
                          brand_status: "reject",
                        },
                        dispatch,
                      )
                    }
                  >
                    <CrossIcon />
                  </CustomButton>
                </div>
              )}
              renderTopToolbarCustomActions={({ table }) => (
                <div className="table-heading-wrap">
                  <h4>{"Brands pending requests"}</h4>
                </div>
              )}
              initialState={{
                columnPinning: {
                  right: ["mrt-row-actions"],
                },
              }}
              //   enableColumnOrdering={false} //enable some features
              //   enableRowSelection={false}
              //   enableColumnResizing={false}
              //   onRowSelectionChange={setRowSelection} //hoist internal state to your own state (optional)
              //   state={{ rowSelection }} //manage your own state, pass it back to the table (optional)
              //   tableInstanceRef={tableInstanceRef} //get a reference to the underlying table instance (optional)
            />
          </Row>
        );
      } else if (brands.loading) {
        return <Spinner />;
      } else {
        return (
          <Container className="no-records mb-4 pb-4">
            <h4 className="title">{"Brands pending requests"}</h4>
            <p>{"No pending brands requests data..."}</p>
          </Container>
        );
      }
    } else if (showBrandUpdateMode) {
      return (
        <Container className="seller-product-create-form modal-custom-class  py-5">
          <BrandCrud
            brand={uploadFormObj}
            setShowBrandCreateMode={setShowBrandUpdateMode}
            setCurrentBrandObj={setUploadFormObj}
            renderInfo={
              <>
                {" "}
                {!isEmpty(uploadFormObj) && (
                  <Row className="m-0 px-0">
                    <Col xs={4} className="px-3">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>{"Seller business name"}</Form.Label>
                        <h6>{uploadFormObj?.user?.business_name}</h6>
                      </Form.Group>
                    </Col>
                    <Col xs={4} className="px-3">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>{"Seller mobile number"}</Form.Label>
                        <h6>{uploadFormObj?.user?.mobile_number}</h6>
                      </Form.Group>
                    </Col>
                    <Col xs={4} className="px-3">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>{"Seller email"}</Form.Label>
                        <h6>{uploadFormObj?.user?.email}</h6>
                      </Form.Group>
                    </Col>
                  </Row>
                )}
              </>
            }
          />
        </Container>
      );
    }
  };

  const OrderDetailsModal = () => {
    return (
      <CustomModalWrap
        className="modal-custom-class order-popup"
        hedaerContent={
          <>
            <h4>{"Order"}</h4>
            <p
              onClick={() => {
                orderViewToggle();
              }}
            >
              <CloseIcon />
            </p>
          </>
        }
        buttonClasses={"action-button hidden"}
        buttonContant={"view"}
        isModalOpen={showOrderModal}
        showModal={orderViewToggle}
        closeModal={orderViewToggle}
      >
        <DashbordOrder
          id={currentOrderId}
          closeModal={orderViewToggle}
          isModalOpen={showOrderModal}
        />
      </CustomModalWrap>
    );
  };

  const [currentEnquiryPkId, setCurrentEnquiryPkId] = useState("");
  const [showEnquiryModel, setEnquiryModal] = useState(false);
  const enquiryViewToggle = () => setEnquiryModal(!showEnquiryModel);
  const EnquiryDetailsModal = () => {
    return (
      <CustomModalWrap
        className="modal-custom-class order-popup"
        hedaerContent={
          <>
            <h4>{"Enquiry"}</h4>
            <p
              onClick={() => {
                enquiryViewToggle();
              }}
            >
              <CloseIcon />
            </p>
          </>
        }
        buttonClasses={"action-button  hidden"}
        buttonContant={"view"}
        isModalOpen={showEnquiryModel}
        showModal={enquiryViewToggle}
        closeModal={enquiryViewToggle}
      >
        <EnquiryDetails
          id={currentEnquiryPkId}
          currentEnquiry={pendingEnquiries.find((enq) => enq.enquiry_pk_id === currentEnquiryPkId)}
        />
      </CustomModalWrap>
    );
  };

  const goToSellers = () => {
    return (
      <Link
        variant="link"
        className="m-0 p-0"
        onClick={() => {
          dispatch({
            type: stringConstants.SET_CURRENT_VIEW,
            payload: stringConstants.USER_SELLERS,
          });
        }}
      >
        Click here
      </Link>
    );
  };

  return (
    <Container className="bhree-admin-dashboard py-2">
      <Row className="mx-0 px-1 mb-4">
        <h1 className=" title text-uppercase">{"Dashboard"}</h1>
      </Row>

      {isFirstDay && (
        <Row className="mx-0 p-0">
          <Alert variant="danger" className="mb-0">
            <ul className="m-0 p-0 list-unstyled">
              <li key={"index-first-day"} className="d-flex align-items-start">
                <span className="me-2 text-danger">✔</span>
                <span>
                  The latest seller payout sheet is available, verify and update. {goToSellers()} to
                  view sellers list.
                </span>
              </li>
            </ul>
          </Alert>
        </Row>
      )}

      {!isEmpty(adminStats?.data) && (
        <Row className="stats-row pb-2">
          <StatCard
            cardTitle={"Total Users"}
            statNumber={adminStats?.data?.users}
            statPecentage="37"
            statIcon={TotalUsers}
          />
          <StatCard
            cardTitle={"Total Brands"}
            statNumber={adminStats?.data?.brands}
            statPecentage="47"
            statIcon={TotalBrands}
          />
          <StatCard
            cardTitle={"Total products"}
            statNumber={adminStats?.data?.products}
            statPecentage="12"
            statIcon={TotalProducts}
          />
        </Row>
      )}

      {OrderDetailsModal()}
      {EnquiryDetailsModal()}

      <div ref={(el) => (scrollRef.current[1] = el)}>{pendingBrands()}</div>
      <div ref={(el) => (scrollRef.current[2] = el)}>{pendingProducts()}</div>
      <div ref={(el) => (scrollRef.current[0] = el)}>{pendingOrders()}</div>
      <div ref={(el) => (scrollRef.current[3] = el)}>{pendingEnquiriesComp()}</div>
    </Container>
  );
};

export default Dashbord;
